import { render } from "./BoxListingInputCell.vue?vue&type=template&id=3804b2d4&scoped=true"
import script from "./BoxListingInputCell.vue?vue&type=script&lang=js"
export * from "./BoxListingInputCell.vue?vue&type=script&lang=js"

import "./BoxListingInputCell.vue?vue&type=style&index=0&id=3804b2d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3804b2d4"]])

export default __exports__